import { Checkin } from 'store/modules/checkins'
import { resolveRatingLabel } from '../../../utils/resolve-rating-label'

export class OverviewVm {
  constructor(private checkin: Checkin) {}

  private get resolved() {
    return resolveRatingLabel({
      status: this.checkin.summaryStatus,
      statusColor: this.checkin.summaryStatusColor,
      statusLabel: this.checkin.summaryStatusLabel,
    })
  }

  get ratingColor(): string | null {
    return this.resolved.color
  }

  get percentageDifferenceText() {
    const sv = this.checkin.summaryScaleValue
    if (sv === 0 || sv === null || !this.checkin.summaryPercentageDifference) {
      return 'Completed'
    }
    return `${this.checkin.summaryPercentageDifference}% ${
      sv > 0 ? 'above' : 'away'
    }`
  }

  get prettifiedSummaryStatus() {
    return this.resolved.text
  }

  get summaryUserText() {
    return this.checkin.author.isCurrentUser
      ? 'You were '
      : `${this.checkin.author.fname} was `
  }
}
